import { render, staticRenderFns } from "./h-bank-header.vue?vue&type=template&id=bcb2cb22&"
import script from "./h-bank-header.vue?vue&type=script&lang=js&"
export * from "./h-bank-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports